import { z } from 'zod'

import type { NoContext } from '~/services/api/contracts/NoContext'
import { PartnerReportIndexQuerySchema, ReportPeriodSchema } from '~/services/api/generated'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

// ListPartnerReportsRequest::prepareForValidation
const normalize = fieldNormalizer({
  enums: [{ field: 'period', options: ReportPeriodSchema.options }]
})

export const PartnerReportIndex = (_context: NoContext = {}) =>
  z.preprocess(normalize, PartnerReportIndexQuerySchema)
